import { useState, useCallback } from 'react';

export const useMatchMultiSelect = <T extends { id: string }>(
  items: T[]
) => {
  const [selectedItems, setSelectedItems] = useState<Set<string>>(new Set());
  const [isMultiSelectMode, setIsMultiSelectMode] = useState(false);

  const toggleMultiSelect = useCallback(() => {
    setIsMultiSelectMode(prev => !prev);
    if (isMultiSelectMode) {
      setSelectedItems(new Set());
    }
  }, [isMultiSelectMode]);

  const toggleItemSelection = useCallback((id: string) => {
    setSelectedItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  }, []);

  const selectAll = useCallback(() => {
    setSelectedItems(new Set(items.map(item => item.id)));
  }, [items]);

  const clearSelection = useCallback(() => {
    setSelectedItems(new Set());
    setIsMultiSelectMode(false);
  }, []);

  const isSelected = useCallback((id: string) => selectedItems.has(id), [selectedItems]);

  return {
    selectedItems,
    isMultiSelectMode,
    toggleMultiSelect,
    toggleItemSelection,
    clearSelection,
    isSelected,
    selectedCount: selectedItems.size,
    selectAll,
    selectedItemIds: Array.from(selectedItems)
  };
};
